//Save value to local storage.
import * as Util from "../Util/Util";

//Local storage API.
declare global {
   interface Storage {
      SetItem(key: string, value: any): void;
      GetItem(key: string): any;
      RemoveItem(key: string): void;
      Exists(key: string): boolean;
   }
}
Storage.prototype.SetItem = function (key: string, value: any) {
   const k: string = document.title.RemoveWhiteSpace() + key;
   if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
      this.setItem(k, value);
   } else {
      this.setItem(k, JSON.stringify(value));
   }
};

//Get value from local storage.
Storage.prototype.GetItem = function (key) {
   const k: string = document.title.RemoveWhiteSpace() + key;
   const value: any = this.getItem(k);

   try {
      JSON.parse(value);
      return value && JSON.parse(value);

   } catch (e) {
      if (value === "true") {
         return true;
      } else if (value === "false") {
         return false;
      }
      return value;
   }
};

//Remove item from local storage.
Storage.prototype.RemoveItem = function (key: string) {
   const k: string = document.title.RemoveWhiteSpace() + key;
   this.removeItem(k);
};

//Check for local storage item exists.
Storage.prototype.Exists = function (key: string) {
   const k: string = document.title.RemoveWhiteSpace() + key;
   if (this[k]) {
      return true;
   }
   return false;
};

//Array definitions.
declare global {
   interface Array<T> {
      Add(obj: any): void;
      InsertAt(index: number, obj: any): void;
      IndexOfNoCase(obj: any): number;
      Remove(obj: any): void;
      RemoveAt(index: number): void;
      Clear(): void;
      Contains(obj: any): boolean;
   }
}

//Add to array.  Note - Use "join" and "split" to handle delimited arrays.
Array.prototype.Add = function (obj: any) {
   this.push(obj);
};

//Insert before an index position into an array. 0=insert at beginning. array.length=insert at end.
Array.prototype.InsertAt = function (index: number, obj: any) {
   this.splice(index, 0, obj);
};

//Indexof case insensitive for string arrays.
Array.prototype.IndexOfNoCase = function (obj: any) {
   let i: number = this.length;
   while (i--) {
      if (this[i].trim().toLowerCase() === obj.trim().toLowerCase()) {
         return i;
      }
   }
   return -1;
};
Array.prototype.Remove = function (obj: any) {
   let pos: number;
   if (typeof obj === "string") {
      pos = this.IndexOfNoCase(obj);
   } else {
      pos = this.indexOf(obj);
   }
   if (pos !== -1) {
      this.splice(pos, 1);
   }
};

//Removes items at a position from an array.
Array.prototype.RemoveAt = function (index: number) {
   this.splice(index, 1);
};

//Clear array.
Array.prototype.Clear = function () {
   this.length = 0;
};

//Array contains case insensitive.
Array.prototype.Contains = function (obj: any) {
   if (typeof obj === "string" && obj !== "") {
      let i: number = this.length;
      while (i--) {
         if (this[i].trim().toLowerCase() === obj.trim().toLowerCase()) {
            return true;
         }
      }
   } else {
      if (this.indexOf(obj) !== -1) {
         return true;
      }
   }
   return false;
};

//String definitions.
declare global {
   interface String {
      IsNumeric(): boolean;
      TrimStart(): string;
      TrimEnd(): string;
      RemoveDouble(): string;
      RemoveWhiteSpace(): string;
      Contains(str: string): boolean;
      Equal(str: string): boolean;
      StartsWith(str: string): boolean;
      EndsWith(str: string): boolean;
      IsValidDate(): boolean;
      ToProperCase(): string;
      SubStr(from: number, numChar?: number): string;
   }
}

//Sub-string.
String.prototype.SubStr = function (from: number, numChar?: number) {
   if (typeof numChar === "undefined") {
      numChar = this.length - from;
   }
   return this.slice(from, from + numChar);
};

//Is string numeric.
String.prototype.IsNumeric = function (): boolean {
   return !isNaN(parseFloat(this)) && isFinite(this);
};

//String trim.
String.prototype.TrimStart = function () {
   return this.replace(/^\s+/, '');
};
String.prototype.TrimEnd = function () {
   return this.replace(/\s+$/, '');
};

//Remove double spaces.
String.prototype.RemoveDouble = function () {
   return this.replace(/\s\s+/g, ' ');
};

//Remove all white space.
String.prototype.RemoveWhiteSpace = function () {
   return this.replace(/\s/g, "");
};

//String contains.
String.prototype.Contains = function (str: string) {
   return this.toLowerCase().indexOf(str.toLowerCase()) !== -1;
};

//String compare.
String.prototype.Equal = function (str: string) {
   return this.toLowerCase() === str.toLowerCase();
};

//String startsWith.
String.prototype.StartsWith = function (str: string) {
   return this.toLowerCase().indexOf(str.toLowerCase()) === 0;
};

//String endsWith.
String.prototype.EndsWith = function (str: string) {
   return this.toLowerCase().indexOf(str.toLowerCase(), this.length - str.length) !== -1;
};

//String is valid date.
String.prototype.IsValidDate = function () {
   const timestamp: number = Date.parse(this);
   if (isNaN(timestamp)) {
      return false;

   } else {
      const txt: string = this.replace(/-/g, "/");
      const sa: string[] = txt.split("/");
      if (sa.length !== 3) {
         return false;
      }
      const month: number = Util.parseInteger(sa[0]);
      const day: number = Util.parseInteger(sa[1]);
      const year: number = Util.parseInteger(sa[2]);
      if (month < 1 || month > 12) {
         return false;
      }
      if (day < 1 || day > 31) {
         return false;
      }
      if (year < 1000 || year > 2050) {
         return false;
      }
      return true;
   }
};

//To mixed case.
String.prototype.ToProperCase = function () {
   let str: string;
   let reg: any;
   let thirdChar: string;

   str = this.replace(/\w\S*/g, function (txt2: string) {
      return txt2.charAt(0).toUpperCase() + txt2.SubStr(1).toLowerCase();
   });

   const lowers: string[] = ['Aka', 'An', 'And', 'As', 'At', 'But', 'By', 'Etal', 'For', 'From', 'In', 'Into', 'Near', 'Nor', 'Of', 'On', 'Onto', 'Or', 'The', 'To', 'With'];
   for (const lower of lowers) {
      reg = new RegExp('\\b' + lower + '\\b', 'g');
      str = str.replace(reg, lower.toLowerCase());
   }

   const uppers: string[] = ['Aif', 'Cp24', 'Dba', 'Ems', 'Emt', 'Fbmc', 'Fsb', 'Ga', 'Gis', 'Gmac', 'Hsbc', 'Id', 'Ii', 'Iii', 'It ', 'Iv', 'Llc', 'Na', 'Nc', 'Ncnb', 'Ot', 'Pca', 'Pt', 'Rmc', 'Rr', 'Sc', 'Usa', 'Ymca'];
   for (const upper of uppers) {
      reg = new RegExp('\\b' + upper + '\\b', 'g');
      str = str.replace(reg, upper.toUpperCase());
   }
   //Fix slashes.
   const pos: number = str.indexOf("/");
   if ((pos !== -1) && (str.length > (pos + 1))) {
      const txt2: string = str.SubStr(pos, 2);
      str = str.replace(txt2, txt2.toUpperCase());
   }

   //Fix McDees.
   const sa: string[] = str.split(" ");

   for (const txt of sa) {
      if (txt.length > 2) {
         if (txt.StartsWith("Mc")) {
            thirdChar = txt.charAt(2);
            if (!Number(thirdChar)) {
               if (txt.length > 3) {
                  str = str.replace(txt, "Mc" + thirdChar.toUpperCase() + txt.SubStr(3));
               }
            }
         }
      }
   }
   return str;
};

//Date definitions.
declare global {
   interface Date {
      toDateInputValue(): string;
      ToShortDate(): string;
      ToSqlDateTime(): string;
   }
}

Date.prototype.toDateInputValue = function () {
   const local: Date = new Date(this);
   local.setMinutes(this.getMinutes() - this.getTimezoneOffset());
   return local.toJSON().slice(0, 10);
};

//Short date.
Date.prototype.ToShortDate = function () {
   if (typeof this === "object") {
      if (this instanceof Date) {
         let month: any;

         try {
            month = this.getUTCMonth();
            if (month !== month) { // if (isNaN(parseFloat(month))) {
               return "";
            }
            return (month + 1) + "/" + this.getUTCDate() + "/" + this.getUTCFullYear();

         } catch (e) {
            try {
               month = this.getMonth();
               return (this.getMonth() + 1) + "/" + this.getDate() + "/" + this.getFullYear();

            } catch (e2) {
               return "";
            }
         }
      }
   }
   return this;
};

//SQL server date.
Date.prototype.ToSqlDateTime = function () {
   if (typeof this === "object") {
      if (this instanceof Date) {

         try {
            let day: string = this.getDate() + "";
            if (day.length === 1) {
               day = "0" + day;
            }

            let month: string = (this.getMonth() + 1) + "";
            if (month.length === 1) {
               month = "0" + month;
            }

            return this.getFullYear() + "-" + month + "-" + day + 'T' + this.toTimeString().SubStr(0, 8);

         } catch (e) {
            return "";
         }
      }
   }
   return this;
};

export {}; //To make this a module.
